__turbopack_context__.v({
  "button": "TermsOfPurchase-module-scss-module__AILU6G__button",
});
